import { onRequest, RequestMethod } from "common/axios/axios"
import { getApiUrl } from "common/axios/getApiUrl"

export class MeetingRepository {
    // 모임 생성
    static onPostCreateMeeting = (params: any) => {
        return onRequest({
            url: getApiUrl('meetings'),
            method: RequestMethod.POST,
            params
        })
    }

    // 내 모임 목록 조회
    static onGetMyMeetings = (params?: { category?: string; status?: string; keyword?: string; page?: number; pageSize?: number }) => {
        return onRequest({
            url: getApiUrl('meetings') + '/list',
            method: RequestMethod.POST,
            params
        })
    }

    // 모임 상세 조회
    static onGetMeetingDetail = (meetingId: string) => {
        return onRequest({
            url: `${getApiUrl('meetingDetail')}/${meetingId}`,
            method: RequestMethod.GET
        })
    }

    // 모임 수정
    static onPutUpdateMeeting = (meetingId: string, params: any) => {
        return onRequest({
            url: `${getApiUrl('meetingDetail')}/${meetingId}`,
            method: RequestMethod.PUT,
            params
        })
    }

    // 모임 삭제
    static onDeleteMeeting = (meetingId: string) => {
        return onRequest({
            url: `${getApiUrl('meetingDetail')}/${meetingId}`,
            method: RequestMethod.DELETE
        })
    }

    // 모임 초대
    static onPostInviteToMeeting = (meetingId: string, params: any) => {
        return onRequest({
            url: `${getApiUrl('meetingInvite')}/${meetingId}/invite`,
            method: RequestMethod.POST,
            params
        })
    }

    // 모임 참여
    static onPostJoinMeeting = (meetingId: string, params?: any) => {
        return onRequest({
            url: `${getApiUrl('meetingJoin')}/${meetingId}/join`,
            method: RequestMethod.POST,
            params
        })
    }

    // 초대 코드로 모임 참여
    static onPostJoinMeetingByCode = (inviteCode: string) => {
        return onRequest({
            url: `${getApiUrl('meetings')}/join-by-code?inviteCode=${inviteCode}`,
            method: RequestMethod.POST
        })
    }

    // 모임 탈퇴
    static onPostLeaveMeeting = (meetingId: string) => {
        return onRequest({
            url: `${getApiUrl('meetingLeave')}/${meetingId}/leave`,
            method: RequestMethod.POST
        })
    }

    // 모임 멤버 조회
    static onGetMeetingMembers = (meetingId: string) => {
        return onRequest({
            url: `${getApiUrl('meetingMembers')}/${meetingId}/members`,
            method: RequestMethod.GET
        })
    }

    // 참석 상태 변경
    static onPutUpdateAttendance = (meetingId: string, attendanceStatus: 'ATTENDING' | 'NOT_ATTENDING' | 'UNDECIDED') => {
        return onRequest({
            url: `${getApiUrl('meetingMembers')}/${meetingId}/members/attendance?attendanceStatus=${attendanceStatus}`,
            method: RequestMethod.PUT
        })
    }

    // ========================================
    // 서브 장소 관리
    // ========================================

    // 서브 장소 목록 조회
    static onGetSubPlaces = (meetingId: string, params?: { category?: string; dayNumber?: number }) => {
        let url = `${getApiUrl('subPlaces')}/${meetingId}/sub-places`;
        const queryParams = new URLSearchParams();
        if (params?.category) queryParams.append('category', params.category);
        if (params?.dayNumber !== undefined) queryParams.append('dayNumber', params.dayNumber.toString());
        if (queryParams.toString()) url += `?${queryParams.toString()}`;
        return onRequest({
            url,
            method: RequestMethod.GET
        })
    }

    // 서브 장소 단건 조회
    static onGetSubPlace = (meetingId: string, subPlaceId: number) => {
        return onRequest({
            url: `${getApiUrl('subPlaces')}/${meetingId}/sub-places/${subPlaceId}`,
            method: RequestMethod.GET
        })
    }

    // 서브 장소 생성
    static onPostCreateSubPlace = (meetingId: string, params: {
        placeName: string;
        placeAddress?: string;
        latitude?: number;
        longitude?: number;
        category: string;
        sortOrder?: number;
        dayNumber?: number;
        visitTime?: string;
        description?: string;
        imageUrl?: string;
        rating?: number;
        priceRange?: string;
        tags?: string;
    }) => {
        return onRequest({
            url: `${getApiUrl('subPlaces')}/${meetingId}/sub-places`,
            method: RequestMethod.POST,
            params
        })
    }

    // 서브 장소 일괄 생성
    static onPostCreateSubPlaces = (meetingId: string, params: Array<{
        placeName: string;
        placeAddress?: string;
        latitude?: number;
        longitude?: number;
        category: string;
        sortOrder?: number;
        dayNumber?: number;
        visitTime?: string;
        description?: string;
    }>) => {
        return onRequest({
            url: `${getApiUrl('subPlaces')}/${meetingId}/sub-places/batch`,
            method: RequestMethod.POST,
            params
        })
    }

    // 서브 장소 수정
    static onPutUpdateSubPlace = (meetingId: string, subPlaceId: number, params: {
        placeName: string;
        placeAddress?: string;
        latitude?: number;
        longitude?: number;
        category: string;
        sortOrder?: number;
        dayNumber?: number;
        visitTime?: string;
        description?: string;
        imageUrl?: string;
        rating?: number;
        priceRange?: string;
        tags?: string;
    }) => {
        return onRequest({
            url: `${getApiUrl('subPlaces')}/${meetingId}/sub-places/${subPlaceId}`,
            method: RequestMethod.PUT,
            params
        })
    }

    // 서브 장소 삭제
    static onDeleteSubPlace = (meetingId: string, subPlaceId: number) => {
        return onRequest({
            url: `${getApiUrl('subPlaces')}/${meetingId}/sub-places/${subPlaceId}`,
            method: RequestMethod.DELETE
        })
    }
}
